import Vue from 'vue'
import App from './App.vue'
import store from './store'
import './mixins/loadMixins'
import './scripts/hammer'
import Carousel3d from 'vue-carousel-3d';
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-180588670-1'
})

Vue.use(Carousel3d);
/*eslint-disable */

// require('aframe')
// require('aframe-extras');
// require("nipplejs");

Vue.config.productionTip = false

Vue.config.ignoredElements = [
  'model-viewer',
  'a-scene',
  'a-asset-item',
  'a-image',
  'a-curvedimage',
  'a-assets',
  'a-text',
  'a-plane',
  'a-cylinder',
  'a-rounded',
  'a-light',
  'a-entity',
  'a-camera',
  'a-box',
  'a-sky',
  'a-cursor',
  'a-gltf-model'
]


new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
